export enum ReportDtoKeysEnum {
  /** Event calendar item API's response body */
  EVENT_CALENDAR_ITEM_FIND_DTO = 'report/event-calendar-item-find.dto',
  /** Event calendar item info API's response body */
  EVENT_CALENDAR_ITEM_INFO_FIND_DTO = 'report/event-calendar-item-info-find.dto',
  /** Event calendar day group API's response body */
  EVENT_CALENDAR_DAY_GROUP_FIND_DTO = 'report/event-calendar-day-group-find.dto',
  /** Event calendar day group API's response body */
  EVENT_CALENDAR_RESULT_FIND_DTO = 'report/event-calendar-result-find.dto',
  /** Event calendar list API's response body */
  EVENT_CALENDAR_PAGE_FIND_DTO = 'report/event-calendar-page-find.dto',
  /** Event calendar widget result info API's response body */
  EVENT_CALENDAR_RESULT_WIDGET_FIND_DTO = 'report/event-calendar-result-widget-find.dto',
  /** Event calendar query params body */
  EVENT_CALENDAR_QUERY_DTO = 'report/event-calendar-query.dto',
  /** Expired event calendar query params body */
  EVENT_CALENDAR_EXPIRED_QUERY_DTO = 'report/event-calendar-expired-query.dto',
  /** BDDS report sums base response body */
  BDDS_REPORT_SUMS_BASE_FIND_DTO = 'report/bdds-report-sums-base-find.dto',
  /** BDDS report sums response body */
  BDDS_REPORT_SUMS_FIND_DTO = 'report/bdds-report-sums-find.dto',
  /** BDDS report direction sums response body */
  BDDS_REPORT_DIRECTION_SUMS_FIND_DTO = 'report/bdds-report-direction-sums-find.dto',
  /** BDDS report company sums response body */
  BDDS_REPORT_COMPANY_SUMS_FIND_DTO = 'report/bdds-report-company-sums-find.dto',
  /** BDDS report unit sums response body */
  BDDS_REPORT_UNIT_SUMS_FIND_DTO = 'report/bdds-report-unit-sums-find.dto',
  /** BDDS report response body */
  BDDS_REPORT_FIND_DTO = 'report/bdds-report-find.dto',
  /** BDDS report item response body */
  BDDS_REPORT_ITEM_FIND_DTO = 'report/bdds-report-item-find.dto',
  /** BDDS report filters response body */
  BDDS_REPORT_FILTERS_FIND_DTO = 'report/bdds-report-filters-find.dto',
  /** BDDS report query params */
  BDDS_REPORT_QUERY_DTO = 'report/bdds-report-query-find.dto',
  /** DDS report BRS task status IDs per column */
  DDS_REPORT_TASK_STATUS_IDS_DTO = 'report/dds-report-task-status-ids.dto',
  /** DDS report item response body */
  DDS_REPORT_ITEM_FIND_DTO = 'report/dds-report-item-find.dto',
  /** DDS report sums response body */
  DDS_REPORT_SUMS_FIND_DTO = 'report/dds-report-sums-find.dto',
  /** DDS report response body */
  DDS_REPORT_FIND_DTO = 'report/dds-report-find.dto',
  /** DDS report filters response body */
  DDS_REPORT_FILTERS_FIND_DTO = 'report/dds-report-filters-find.dto',
  /** DDS report API query parameters */
  DDS_REPORT_QUERY_DTO = 'report/dds-report-query.dto',
  /** DDS task query response body */
  DDS_TASK_QUERY_DTO = 'report/dds-task-query.dto',
  /** DDS task response body */
  DDS_TASK_FIND_DTO = 'report/dds-task-find.dto',
  /** Document report filters response body */
  DOCUMENT_REPORT_FILTERS_DTO = 'report/document-report-filters.dto',
  /** Document type response body */
  DOCUMENT_TYPE_FIND_DTO = 'report/document-type-find.dto',
  /** Document report response body */
  DOCUMENT_REPORT_FIND_DTO = 'report/document-report-find.dto',
  /** Document report item response body */
  DOCUMENT_REPORT_ITEM_FIND_DTO = 'report/document-report-item-find.dto',
  /** Document report query params body */
  DOCUMENT_REPORT_QUERY_DTO = 'report/document-report-query.dto',
  /** P&L report filters response body */
  PNL_REPORT_FILTERS_DTO = 'report/pnl-report-filters.dto',
  /** P&L report query params body */
  PNL_REPORT_QUERY_DTO = 'report/pnl-report-query.dto',
  /** P&L report ranges response body */
  PNL_REPORT_RANGES_FIND_DTO = 'report/pnl-report-ranges-find.dto',
  /** P&L report item ranges response body */
  PNL_REPORT_ITEM_FIND_DTO = 'report/pnl-report-item-find.dto',
  /** P&L report item period response body */
  PNL_REPORT_ITEM_PERIOD_VALUE_FIND_DTO = 'report/pnl-report-item-period-value-find.dto',
  /** P&L report response body */
  PNL_REPORT_FIND_DTO = 'report/pnl-report-find.dto',
  /** Reference direction item response body */
  REFERENCE_DIRECTION_ITEM_FIND_DTO = 'report/reference-direction-item-find.dto',
  /** Reference copy month query params body */
  REFERENCE_COPY_MONTH_QUERY_DTO = 'report/reference-copy-month-query.dto',
  /** Reference item base response body */
  REFERENCE_ITEM_BASE_FIND_DTO = 'report/reference-item-base-find.dto',
  /** Reference item response body */
  REFERENCE_ITEM_FIND_DTO = 'report/reference-item-find.dto',
  /** Reference report query response body */
  REFERENCE_REPORT_QUERY_DTO = 'report/reference-report-query.dto',
  /** Reference report query params */
  REFERENCE_TOTAL_FIND_DTO = 'report/reference-total-find.dto',
}
